import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import Helmet from 'react-helmet';

import cx from 'classnames';
import config from '../config';
import history from '../modules/history';
import { RoutePublic, RoutePrivate, RouteVariant, RouteHome } from '../routers';
import { setAuthToken } from '../modules/client';

import { StyleTest } from '../presentation/StyleTest';
import NotFound from '../routes/NotFound';
import LoginContainer from '../containers/LoginContainer';
import SignupContainer from '../containers/SignupContainer';
import OAuthCallbackContainer from '../containers/OAuthCallbackContainer';
import ForgotPasswordContainer from '../containers/ForgotPasswordContainer';
import ResetPasswordContainer from '../containers/ResetPasswordContainer';
import PageContainer from '../containers/PageContainer';
import LeadContainer from '../containers/LeadContainer';
import ActivityContainer from '../containers/ActivityContainer';
import DomainContainer from '../containers/DomainContainer';
import GalleryContainer from '../containers/GalleryContainer';
import { User } from '../presentation/User';
import EditorContainer from '../containers/EditorContainer';
import UpdateAvailableAlert from '../components/UpdateAvailableAlert';
import NetworkErrorAlert from '../components/NetworkErrorAlert';


const App = ({
  app,
  dispatch,
  session,
}) => {

  const [tokenSaved, setTokenSaved] = useState(false);

  if (!tokenSaved && session && session.isAuthenticated) {
    // Call once before render
    setAuthToken(session.token);
    setTokenSaved(true);
  }

  // useEffect(() => {
  //   if ('email' in session) {
  //     // call identify here
  //   }
  // }, []);

  // useEffect(() => {
  //   if(session.isAuthenticated === true) {
  //     // call identify here
  //   }
  //   else {
  //     // setGA({ userId: null });
  //     // call identify here with user id null or empty string
  //   }
  // }, [session]);

  const privateProps = {
    session: session,
    networkError: app.error,
    // email: session.email,
  };

  return (
    <ConnectedRouter history={history}>
      <div
        className={cx('app', {
          'app--private': session.isAuthenticated,
          'app__network__disconnected': app.error,
        })}
      >
        <Helmet
          defer={false}
          htmlAttributes={{ lang: 'en-us' }}
          encodeSpecialCharacters={true}
          defaultTitle={config.title}
          titleTemplate={`%s | ${config.title}`}
          titleAttributes={{ itemprop: 'name', lang: 'en-us' }}
        />

        <Switch>
          <RouteHome session={session} path="/" exact />

          <RoutePublic session={session} path="/login" exact component={LoginContainer} />
          <RoutePublic session={session} path="/signup" exact component={SignupContainer} />
          <RoutePublic session={session} path="/signup/plan/:plan" exact component={SignupContainer} />
          <RoutePublic session={session} path="/signup/promo/:promo" exact component={SignupContainer} />
          <RoutePublic session={session} path="/forgot-password" exact component={ForgotPasswordContainer} />
          <RoutePublic session={session} path="/reset-password/:code" exact component={ResetPasswordContainer} />
          <RoutePublic session={session} path="/oauth/:provider" exact component={OAuthCallbackContainer} />

          {
            (process.env.NODE_ENV !== 'production') &&
            <RoutePrivate {...privateProps} path="/style-test" component={StyleTest} />
          }

          <RoutePrivate {...privateProps} path="/pages" component={PageContainer} />
          <RoutePrivate {...privateProps} path="/domains" component={DomainContainer} />
          <RoutePrivate {...privateProps} path="/gallery" component={GalleryContainer} />
          <RoutePrivate {...privateProps} path="/user" component={User} />
          <RoutePrivate {...privateProps} path="/activities" component={ActivityContainer} />

          <RouteVariant {...privateProps} path="/editor/:variantUrlsafe" exact component={EditorContainer} tutorial={false} />
          <RouteVariant {...privateProps} path="/editor/tutorial/:variantUrlsafe" exact component={EditorContainer} tutorial={true} />

          <RoutePrivate {...privateProps} path="/leads" component={LeadContainer} />

          <Route component={NotFound} />
        </Switch>

        <UpdateAvailableAlert {...app} />
        <NetworkErrorAlert {...app} dispatch={dispatch} currentLocation={history.location.pathname} />

      </div>
    </ConnectedRouter>
  );
};

const mapStateToProps = (state) => ({
  app: state.app,
  session: state.session,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./scripts/containers/App.jsx